import { RepositoryBase } from '@app/repositories/RepositoryBase';

export class ProcessTypeRepository<ProcessTypeModel> extends RepositoryBase<ProcessTypeModel> {
    public constructor() {
        super('processType');
    }
}
